// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom styles for Customer Budget Planning System */

/* Font Imports */

/* Font Classes */
.font-heading {
  font-family: 'Manrope', sans-serif;
}

.font-body {
  font-family: 'Inter', sans-serif;
}

.font-mono {
  font-family: 'JetBrains Mono', monospace;
}

/* Smooth Scrolling */
html {
  scroll-behavior: smooth;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Table Selection Styles */
.budget-cell-selected {
  box-shadow: inset 0 0 0 2px #3b82f6;
}

.budget-cell-editing {
  background-color: #eff6ff;
}

/* Animation for pasted cells */
@keyframes paste-highlight {
  0% {
    background-color: #fef3c7;
  }
  100% {
    background-color: transparent;
  }
}

.paste-highlight {
  animation: paste-highlight 1s ease-out;
}

/* Floating panel shadow */
.floating-shadow {
  box-shadow: 
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -2px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(0, 0, 0, 0.05);
}

/* Table hover effect */
.table-row-hover:hover td {
  background-color: #f9fafb;
}

/* Focus ring for accessibility */
.focus-ring {
  outline: none;
  box-shadow: 0 0 0 2px #3b82f6;
}

/* Sticky header shadow when scrolling */
.sticky-header-shadow {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Input number hide spinners */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

/* Smooth transitions for interactive elements */
button,
input,
select,
a {
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;
}

/* Loading skeleton animation */
@keyframes skeleton-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.skeleton-loading {
  animation: skeleton-pulse 2s ease-in-out infinite;
}

/* Tab indicator animation */
.tab-indicator {
  transition: transform 0.2s ease, width 0.2s ease;
}

/* Badge styles */
.badge-completed {
  background-color: #dcfce7;
  color: #166534;
}

.badge-pending {
  background-color: #f3f4f6;
  color: #4b5563;
}

/* Action bar blur effect */
.action-bar-blur {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

/* Grid pattern background (optional) */
.grid-pattern {
  background-image: 
    linear-gradient(to right, #f0f0f0 1px, transparent 1px),
    linear-gradient(to bottom, #f0f0f0 1px, transparent 1px);
  background-size: 20px 20px;
}

/* Variance indicators */
.variance-positive {
  color: #16a34a;
}

.variance-negative {
  color: #dc2626;
}

/* Table container scroll shadows */
.table-scroll-shadow {
  background: 
    linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
    linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
    radial-gradient(farthest-side at 0 50%, rgba(0, 0, 0, 0.1), transparent),
    radial-gradient(farthest-side at 100% 50%, rgba(0, 0, 0, 0.1), transparent) 100% 0;
  background-repeat: no-repeat;
  background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
  background-attachment: local, local, scroll, scroll;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD,iBAAiB;;AAGjB,iBAAiB;AACjB;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE;;;iCAG+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA,wCAAwC;AACxC;EACE,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;;;;EAIE,yGAAyG;AAC3G;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iDAAiD;AACnD;;AAEA,4BAA4B;AAC5B;EACE,gDAAgD;AAClD;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,uCAAuC;AACvC;EACE;;4DAE0D;EAC1D,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE;;;;sFAIoF;EACpF,4BAA4B;EAC5B,2DAA2D;EAC3D,mDAAmD;AACrD","sourcesContent":["/* Custom styles for Customer Budget Planning System */\n\n/* Font Imports */\n@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@400;500;600&display=swap');\n\n/* Font Classes */\n.font-heading {\n  font-family: 'Manrope', sans-serif;\n}\n\n.font-body {\n  font-family: 'Inter', sans-serif;\n}\n\n.font-mono {\n  font-family: 'JetBrains Mono', monospace;\n}\n\n/* Smooth Scrolling */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Custom Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n}\n\n/* Table Selection Styles */\n.budget-cell-selected {\n  box-shadow: inset 0 0 0 2px #3b82f6;\n}\n\n.budget-cell-editing {\n  background-color: #eff6ff;\n}\n\n/* Animation for pasted cells */\n@keyframes paste-highlight {\n  0% {\n    background-color: #fef3c7;\n  }\n  100% {\n    background-color: transparent;\n  }\n}\n\n.paste-highlight {\n  animation: paste-highlight 1s ease-out;\n}\n\n/* Floating panel shadow */\n.floating-shadow {\n  box-shadow: \n    0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -2px rgba(0, 0, 0, 0.1),\n    0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n\n/* Table hover effect */\n.table-row-hover:hover td {\n  background-color: #f9fafb;\n}\n\n/* Focus ring for accessibility */\n.focus-ring {\n  outline: none;\n  box-shadow: 0 0 0 2px #3b82f6;\n}\n\n/* Sticky header shadow when scrolling */\n.sticky-header-shadow {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n/* Input number hide spinners */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* Smooth transitions for interactive elements */\nbutton,\ninput,\nselect,\na {\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;\n}\n\n/* Loading skeleton animation */\n@keyframes skeleton-pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.skeleton-loading {\n  animation: skeleton-pulse 2s ease-in-out infinite;\n}\n\n/* Tab indicator animation */\n.tab-indicator {\n  transition: transform 0.2s ease, width 0.2s ease;\n}\n\n/* Badge styles */\n.badge-completed {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.badge-pending {\n  background-color: #f3f4f6;\n  color: #4b5563;\n}\n\n/* Action bar blur effect */\n.action-bar-blur {\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n/* Grid pattern background (optional) */\n.grid-pattern {\n  background-image: \n    linear-gradient(to right, #f0f0f0 1px, transparent 1px),\n    linear-gradient(to bottom, #f0f0f0 1px, transparent 1px);\n  background-size: 20px 20px;\n}\n\n/* Variance indicators */\n.variance-positive {\n  color: #16a34a;\n}\n\n.variance-negative {\n  color: #dc2626;\n}\n\n/* Table container scroll shadows */\n.table-scroll-shadow {\n  background: \n    linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),\n    linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,\n    radial-gradient(farthest-side at 0 50%, rgba(0, 0, 0, 0.1), transparent),\n    radial-gradient(farthest-side at 100% 50%, rgba(0, 0, 0, 0.1), transparent) 100% 0;\n  background-repeat: no-repeat;\n  background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;\n  background-attachment: local, local, scroll, scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
